<ui-loading variant="spinner" [loading]="state === 'loading'">
<div class="container">
    <div class="login">
        <form [formGroup]="fiLoginForm" (ngSubmit)="onSubmit()">
            <div class="login_textblock">
                <p class="login_title">
                    <slot name="flowsFIRenewalLoginTitleText"></slot>
                </p>
                <p class="login_description margin-bottom">
                    <slot name="flowsFIRenewalLoginInstructionsText"></slot>
                </p>
            </div>
            <div class="login_inputs">
                <div>
                    <ui-input (ngModel)="customerno" name="customerno" formControlName="customerno">
                        <slot name="flowsFIRenewalLoginCustomerNumberLabel"></slot>
                        <slot title name="flowsFIRenewalLoginCustomerNumberTitle"></slot>
                        <slot error name="flowsFIRenewalLoginCustomerNumberError"></slot>
                    </ui-input>
                </div>
                <div>
                    <ui-input (ngModel)="agreementno" name="agreementno" formControlName="agreementno">
                        <slot name="flowsFIRenewalLoginAgreementNumberLabel"></slot>
                        <slot title name="flowsFIRenewalLoginAgreementNumberTitle"></slot>
                        <slot error name="flowsFIRenewalLoginAgreementNumberError"></slot>
                    </ui-input>
                </div>
            </div>
            <p class="login_error" *ngIf="state === 'errorred'">
                <span>
                        <slot name="flowsFIRenewalLoginErrorText"></slot>
                    </span>
            </p>
            <div class="login_button">
                <button ui-button variant="primary" fluid="true" type="submit" [disabled]="state === 'loading'">
                    <slot #loader name="flowsFIRenewalLoginButtonText"></slot>
                </button>
            </div>
        </form>
    </div>
</div>
</ui-loading>